import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { User as UserType } from "@shared/types/graphqlGenerated";

const UserId_Shared_Query = gql`
  query UserId_Shared_Query {
    viewer {
      user {
        id
      }
    }
  }
`;

type User = Pick<UserType, "id">;

interface UserIdQueryData {
  viewer: {
    user: User;
  };
}

const useUserIdQuery = (options?: QueryHookOptions<UserIdQueryData>) =>
  useQuery<UserIdQueryData>(UserId_Shared_Query, options);

export type { UserIdQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useUserIdQuery, UserId_Shared_Query };
